<aa-input-switch
    name="all"
    label="{{ 'CHIPS.SHOW' | translate }}"
    [checked]="chipsState | async"
    (toggleSwitch)="onToggleShowChips($event)"
>
</aa-input-switch>
